import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImportCertificateHolder from '../../../../../shared/Cis/CertificateHolders/Import/ImportCertificateHolder';
import reducer, { defaultState, updateFieldCreator, setErrorsCreator } from './reducer';
import { useReducer } from 'react';
import { useEffect } from 'react';
import { importDataCreator } from '../../../../../store/actionsCreators';

const ImportMaCertificateHolder = ({ certificationBodies, userCb, importData, importErrors }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  useEffect(() => {
    if (!state.certificationBody && userCb && Number.isInteger(userCb)) {
      dispatch(updateFieldCreator({ name: 'certificationBody', value: userCb }));
    }
  }, [state.certificationBody, userCb, dispatch]);

  return (
    <ImportCertificateHolder
      type="ma"
      certificationBodies={certificationBodies}
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      setErrorsCreator={setErrorsCreator}
      importData={importData}
      importErrors={importErrors}
    />
  );
};

ImportMaCertificateHolder.propTypes = {
  certificationBodies: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({ globals, user }) => ({
  certificationBodies: globals.cis.certificationBodies,
  userCb: user.user.memberAssociation?.certificationBody?.id,
  importErrors: globals.cis.importErrors,
});

const mapDispatchToProps = (dispatch) => ({
  importData: (params) => dispatch(importDataCreator(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportMaCertificateHolder);
